import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  useTheme, 
  useMediaQuery
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { green } from '@material-ui/core/colors';
import { STATUS_API } from 'src/app/constant/config';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { getServicePackage, selectServicePackage } from 'src/features/deviceSlice';
import CustomDialog from 'src/app/components/CustomDialog';

// Chon goi cuoc gia han cho admin va agency
function EditDeviceModal({ open, onClose, device }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const statusCreate = useSelector(state => state.staffSlice.statusCreate);
  const listPackage = useSelector(state => state.deviceSlice.listPackage);

  const [description, setDescription] = useState([]);

  const serviceOption = (listPackage || [])?.map(item => {
    return {
      id: Number(item.id),
      cost: item.cost,
      name: item.name,
      description: item.description,
    };
  });

  useEffect(() => {
    if (device.id) {
      dispatch(
        getServicePackage({
          device_type_id: device?.deviceType?.id,
          version: device?.hardware_version
        })
      );
    }
  }, [device]);

  const handleSubmit = data => {
    const newData = {
      service_package_id: Number(data.service_package_id)
    };

    dispatch(
      selectServicePackage({
        data: newData,
        id: device.id
      })
    );
    onClose();
    setDescription('');
  };

  const handleClose = () => {
    onClose();
    setDescription('');
  };

  const handleSelectPackage = (event, value, setFieldValue) => {
    const selectedPackage = serviceOption.find(
      (pkg) => pkg.id === Number(value.id)
    );
    if (selectedPackage) {
      setDescription(selectedPackage.description);
    }
    setFieldValue('service_package_id', Number(value.id));
  }

  return (
    <CustomDialog title="Chọn gói dịch vụ gia hạn" open={open} onClose={handleClose}>
      <div>
        <Formik
          initialValues={{
            serial: device.serial,
            version: device.hardware_version,
            service_package_id: '',
            description: device?.description || ''
          }}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            service_package_id: Yup.string()
              .max(100)
              .required('Vui lòng chọn gói dịch vụ gia hạn')
          })}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Serial thiết bị <span style={{ color: 'red' }}></span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    disabled={true}
                    helperText={touched.email && errors.email}
                    margin="normal"
                    className="input-no-fieldset"
                    name="email"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.serial}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Phiên bản <span style={{ color: 'red' }}></span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.version && errors.version)}
                    className="input-no-fieldset"
                    fullWidth
                    disabled={true}
                    helperText={touched.version && errors.version}
                    margin="normal"
                    name="description"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.version}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel style={{ marginBottom: "21px" }}>
                    Gói dịch vụ gia hạn <span className="text-danger">*</span>
                  </InputLabel>
                  <Autocomplete
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    size="small"
                    options={serviceOption || []}
                    getOptionLabel={option => option.name}
                    value={(serviceOption || []).find(
                      option => option.name === values.service_package_id
                    )}
                    onChange={(e, value) => handleSelectPackage(e, value, setFieldValue)}
                    disableClearable
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Chọn gói dịch vụ"
                        name="service_package_id"
                        error={Boolean(
                        touched.service_package_id && errors.service_package_id
                        )}
                        helperText={
                          touched.service_package_id && errors.service_package_id
                        }
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '35px',
                          }
                        }}
                      />
                    )}
                    className={classes.customOutline}
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Mô tả <span style={{ color: 'red' }}></span>
                  </InputLabel>
                  <TextField
                    fullWidth
                    disabled={true}
                    margin="normal"
                    className="input-no-fieldset"
                    name="email"
                    size="small"
                    onBlur={handleBlur}
                    value={description}
                    variant="outlined"
                  />
                </Grid>

              </Grid>
              <Box my={3}>
                <div className={classes.groupButtonSubmit}>
                  <div className={classes.wrapper}>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 90 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      onClick={() => onClose()}
                      className="btn-main btn-plain mx-3"
                      color="primary"
                      size="large"
                      variant="contained"
                    >
                      Thoát
                    </Button>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 120 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      className="btn-main mx-3"
                      color="primary"
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Lưu lại
                    </Button>
                    {statusCreate === STATUS_API.PENDING && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </div>
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',

    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
   customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    },
  }
}));

export default React.memo(EditDeviceModal);
